'use client';

import type { ReactNode } from 'react';
import { useEffect, useRef, useState } from 'react';
interface UseBottomCTAAnimationParams {
  isHidden: boolean;
  toastContent?: ReactNode;
}
export const useBottomCTAAnimation = ({
  isHidden,
  toastContent
}: UseBottomCTAAnimationParams) => {
  const [isBottomVisible, setIsBottomVisible] = useState(false);
  const [isToastVisible, setIsToastVisible] = useState(false);
  const lastToastContent = useRef<ReactNode>(null);

  // eslint-disable-next-line react-hooks/refs -- 퇴장 애니메이션 동안 마지막 토스트 내용을 유지하는 의도적 최신값 ref 패턴
  if (toastContent) lastToastContent.current = toastContent;
  useEffect(() => {
    if (!isHidden) {
      const bottomTimer = setTimeout(() => {
        setIsBottomVisible(true);
      }, 100);
      const toastTimer = setTimeout(() => {
        setIsToastVisible(true);
      }, 400);
      return () => {
        clearTimeout(bottomTimer);
        clearTimeout(toastTimer);
      };
    } else {
      // eslint-disable-next-line react-hooks/set-state-in-effect -- 타이머 기반 입·퇴장 애니메이션 시퀀스로 숨김 시 토스트를 즉시 끄는 의도적 동기화
      setIsToastVisible(false);
      const hideTimer = setTimeout(() => {
        setIsBottomVisible(false);
      }, 150);
      return () => clearTimeout(hideTimer);
    }
  }, [isHidden]);
  return {
    isBottomVisible,
    isToastActive: isToastVisible && !!toastContent,
    // eslint-disable-next-line react-hooks/refs -- 퇴장 애니메이션 동안 마지막 토스트 내용을 보여주기 위한 렌더 중 ref 읽기
    displayToastContent: toastContent ?? lastToastContent.current
  };
};